/**
 * 외부 PG SDK script 동적 로드.
 *
 * - 같은 src 캐시 — 두 번 로드 안 함
 * - 실패 시 캐시에서 제거 → 다음 시도에서 재로드
 */
const cache = new Map<string, Promise<void>>()

export function loadScript(src: string): Promise<void> {
  const cached = cache.get(src)
  if (cached) return cached

  const promise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`)
    if (existing) {
      resolve()
      return
    }
    const el = document.createElement('script')
    el.src = src
    el.async = true
    el.onload = () => resolve()
    el.onerror = () => reject(new Error(`script load failed: ${src}`))
    document.head.appendChild(el)
  })

  cache.set(src, promise)
  promise.catch(() => cache.delete(src))
  return promise
}
